/** Injected so tests can control time instead of waiting for it. */
export interface ClockPort {
  now(): Date;
}

export const systemClock: ClockPort = { now: () => new Date() };

export function fixedClock(instant: Date | string): ClockPort {
  const value = typeof instant === 'string' ? new Date(instant) : instant;
  return { now: () => new Date(value) };
}
